import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import * as Components from '_components';
export function Tabs2(props) {
    const [selectedId, setSelectedId] = React.useState('');
    const allTabs = React.Children.map(props.children, child => {
        if (React.isValidElement(child) && child.type === Tab2) {
            const tabProps = child.props;
            return { id: tabProps.id, title: tabProps.title };
        }
    }) ?? [];
    React.useEffect(() => {
        if (props.selectedId) {
            setSelectedId(props.selectedId);
        }
        else if (allTabs.length > 0) {
            setSelectedId(allTabs[0].id);
        }
    }, [props.selectedId]);
    return (_jsxs(Components.Frame, { children: [_jsx(Components.FrameComponent, { side: Components.FrameComponentType.Top, type: Components.FrameSideType.Big, children: _jsx(Components.Layout, { type: Components.LayoutType.HorizontalStack, children: _jsx(Components.LayoutArea, { name: Components.LayoutAreasNames.Stack.Main, children: _jsx(Components.BtnGroup, { children: allTabs.map(tab => (_jsx(Components.Button, { onClick: () => setSelectedId(tab.id), isActive: tab.id === selectedId, children: _jsx(Common.MLT, { text: tab.title }) }, tab.id))) }) }) }) }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Bottom, type: Components.FrameSideType.Big }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Content, children: React.Children.map(props.children, child => {
                    if (React.isValidElement(child) && child.type === Tab2) {
                        if (child.props.id === selectedId) {
                            return child;
                        }
                    }
                    else {
                        return child;
                    }
                }) })] }));
}
export function Tab2(props) {
    return _jsx(_Fragment, { children: props.children });
}
export function TabsContent(props) {
    for (const tab of props.tabs) {
        if (tab.properties?.id === props.selectedId) {
            return Components.RenderChildren(tab.children);
        }
    }
    if (props.tabs.length > 0) {
        return Components.RenderChildren(props.tabs[0].children);
    }
    return _jsx(_Fragment, {});
}
export function TabsHeader(props) {
    return (_jsx(Components.BtnGroup, { children: props.tabs.map((tab, index) => (_jsx(Components.Button, { onClick: () => props.setSelected(tab.properties.id), isActive: tab.properties?.id === props.selectedId, children: _jsx(Components.Title, { ...tab.properties }) }, index))) }));
}
export function TabsWidget(props) {
    return (_jsxs(Components.Frame, { children: [_jsx(Components.FrameComponent, { side: Components.FrameComponentType.Top, type: Components.FrameSideType.Big, children: _jsxs(Components.Layout, { type: Components.LayoutType.HorizontalStack, children: [_jsx(Components.LayoutArea, { name: Components.LayoutAreasNames.Stack.Main, children: _jsx(TabsHeader, { ...props }) }), _jsx(Components.LayoutArea, { name: Components.LayoutAreasNames.Stack.Side, children: _jsx("h1", { children: Components.Text(props.title) }) })] }) }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Bottom, type: Components.FrameSideType.Big, children: _jsxs(Components.Layout, { type: Components.LayoutType.HorizontalStack, children: [_jsx(Components.LayoutArea, { name: Components.LayoutAreasNames.Stack.Main }), _jsx(Components.LayoutArea, { name: Components.LayoutAreasNames.Stack.Side, children: props.extraBtns })] }) }), _jsx(Components.FrameComponent, { side: Components.FrameComponentType.Content, children: _jsx(TabsContent, { ...props }, props.selectedId) })] }));
}
export function Tabs(component, index) {
    const [selected, setSelected] = React.useState('');
    const tabs = FIlterTabComponents(component);
    return (_jsx(TabsWidget, { tabs: tabs, selectedId: selected, setSelected: id => setSelected(id), title: Components.TitleText(component.properties) }));
}
export function SettingsDialogTabs(component, index) {
    const dialogCtx = Common.useSettingsDialog();
    const tabs = FIlterTabComponents(component);
    const closeBtn = (_jsx(Components.BtnGroup, { children: _jsx("button", { onClick: () => dialogCtx.setTab(Common.SettingsTabs.None), children: "Close" }) }));
    return (_jsx(TabsWidget, { tabs: tabs, selectedId: dialogCtx.tab, setSelected: id => dialogCtx.setTab(id), title: Components.TitleText(component.properties), extraBtns: closeBtn }));
}
function FIlterTabComponents(component) {
    const tabs = [];
    if (component.children) {
        for (const child of component.children) {
            if (child.type.toLowerCase() === 'tab') {
                tabs.push(child);
            }
            // todo fix this
            // if (child.type.toLowerCase() === 'if') {
            //     const nested = IfRender(child);
            //     for (const n of nested || []) {
            //         tabs.push(n);
            //     }
            // }
        }
    }
    return tabs;
}
export function TabsDebug(component, index) {
    function tab(id, group) {
        return {
            type: 'tab',
            properties: { id: id, title: 'Tab ' + id, group },
            children: [{ type: 'Title', properties: { text: 'Tab ' + id } }],
        };
    }
    const tabs = [
        tab('1', null),
        tab('2', null),
        tab('3.1', 'Grp 1'),
        tab('3.2', 'Grp 1'),
        tab('3.3', 'Grp 1'),
        tab('3.4', 'Grp 1'),
        tab('4.1', 'Grp 2'),
        tab('4.2', 'Grp 2'),
        tab('4.3', 'Grp 2'),
        tab('4.4', 'Grp 2'),
    ];
    const cmp = {
        type: 'tabs',
        properties: { title: 'Title' },
        children: tabs,
    };
    return Tabs(cmp, index);
}
